import { SVGProps } from "react";

const Block = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.364 3.63604C17.9926 5.26472 19 7.51472 19 10C19 14.9706 14.9706 19 10 19C7.51472 19 5.26472 17.9926 3.63604 16.364M16.364 3.63604C14.7353 2.00736 12.4853 1 10 1C5.02944 1 1 5.02944 1 10C1 12.4853 2.00736 14.7353 3.63604 16.364M16.364 3.63604L3.63604 16.364"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Block;
